export default function($log, ApiClass) {
  'ngInject';

  const vm = this;
  $log.debug('Bundle Component Activated');
  vm.loaded = false;
  vm.$onInit = activate;

  function activate() {
    vm.error = {};

    if (vm.bundle) {
      return (vm.loaded = true);
    }

    // TODO: Bundle get Id call
  }
}



// WEBPACK FOOTER //
// ./src/app/components/bundle/controller.js